module.exports = "::ng-deep .my-class .modal-dialog {\n  max-width: 80%;\n  width: 80%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/management/user-module-role/user-module-role.component.scss
// module id = ./src/app/components/management/user-module-role/user-module-role.component.scss
// module chunks = main